import { useRef } from 'react';

/**
 * The value while it is there, otherwise the last one it had.
 *
 * Insights keys each answer by its filters, so a filter change reads a new, still empty entry.
 * Holding on to the previous answer until the new one lands lets the page dim and refresh in place
 * instead of dropping back to its skeleton. Null only until the first answer arrives.
 */
const useLastSettled = <T>(value: T | null | undefined): T | null => {
  const lastSettled = useRef<T | null>(null);
  if (value != null) {
    lastSettled.current = value;
  }
  return value ?? lastSettled.current;
};

export default useLastSettled;
